import { Grid } from '@mui/joy'
import AppCard from '../../../components/module/AppCard/AppCard'
import { AndroidLogoIcon, AppleLogoIcon, AppStoreLogoIcon, GooglePlayLogoIcon } from '@phosphor-icons/react'
import { AppProfile } from '../../../components/app/App'
import LayoutSettings from '../../../components/layout/LayoutSettings'

export default function PageApps() {
    const domain = window.location.origin

    const apps = {
        ios: `${domain}/download/ios`,
        android: `${domain}/download/android`,
        googleplay: `https://play.google.com/store/apps/details?id=aquarium.app`,
        mac: `${domain}/download/macos`,
        windows: `${domain}/download/windows`,
        web: `${domain}`,
    }

    return (
        <AppProfile
            title="Мобильные приложения"
            desc="Мобильные приложения мессенджера Аквариум"
        >
            <LayoutSettings header="Приложения" showBack={false}>
                <Grid container spacing={3}>

                    <Grid xs={12} sm={6}>
                        <AppCard
                            title="iOS"
                            link={apps.ios}
                            linkQr={apps.ios}
                            icon={<AppleLogoIcon size={20} weight='fill' />}
                            moreLink={{
                                title: 'App Store',
                                href: apps.ios,
                                icon: <AppStoreLogoIcon size={18} />
                            }}
                        />
                    </Grid>
                    <Grid xs={12} sm={6}>
                        <AppCard
                            title="Android"
                            link={apps.android}
                            linkQr={apps.googleplay}
                            target="_self"
                            icon={<AndroidLogoIcon size={20} weight='fill' />}
                            moreLink={{
                                title: 'Google Play',
                                href: apps.googleplay,
                                icon: <GooglePlayLogoIcon size={18} />
                            }}
                        />
                    </Grid>

                    {/* <Grid xs={12} sm={6}>
                        <AppCard title="macOS" link={apps.mac} />
                    </Grid>
                    <Grid xs={12} sm={6}>
                        <AppCard title="Windows" link={apps.windows} />
                    </Grid> */}

                </Grid>
            </LayoutSettings>
        </AppProfile>
    )
}
